
import { MenuItem } from '@/modules/layout'
import { defineComponent, PropType } from 'vue'
import { useRoute } from 'vue-router'

export default defineComponent({
    name: 'layout-menu-item',
    props: {
        item: {
            type: Object as PropType<MenuItem>,
            required: true
        }
    },
    setup () {
        const route = useRoute()
        return {
            route
        }
    }
})

